import { langStore } from "~/stores/lang";
import { ALL_LANGS } from '~/const';

export function useLang() {
	const { lang } = langStore(langState => ({
		lang: langState.data.lang,
	}));

	return {
		lang,
		isCzech: lang === ALL_LANGS.czech,
	};
}
